var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentDiscountPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.471,
    height: 39.915,
    viewBox: "0 0 88.471 39.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21070",
    "data-name": "Group 21070",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2850",
    "data-name": "Rectangle 2850",
    width: 88.471,
    height: 36.074,
    transform: "translate(-8 0)",
    fill: "#5bc89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42496",
    "data-name": "Path 42496",
    d: "M4733,6426.919h9l-9,3.953Z",
    transform: "translate(-4661.547 -6390.958)",
    fill: "#477965"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDiscountPercent);
export default __webpack_public_path__ + "static/media/payment_discount_percent.b3015cc1a9b6e3913110586053068f17.svg";
export { ForwardRef as ReactComponent };